
<template>
    <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="sign-photo-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
        <vs-tabs :color="colorx">
            <vs-tab @click="CloseCamera" label="Signature">
            <div class="con-tab-ejemplo">
                <VueSignaturePad
                    id="signature"
                    width="100%"
                    height="300px"
                    ref="signaturePad"
                    v-if="!signature"
                    :options="{onBegin: () => {$refs.signaturePad.resizeCanvas()}}"
                />

                <img :src="image_signature" class="w-10/12" v-if="signature" />
                <div class="row flex" v-if="!signature">
                    <div class="vx-col md:w-1/2  w-full mt-2">
                    <vs-button color="primary" class="pr-4 pl-4" type="border" @click="save_signature">Enregistrer</vs-button>
                    </div>
                    <div class="vx-col md:w-1/2  w-full text-right  mt-2">
                    <vs-button color="primary" class="pr-4 pl-4" type="border" @click="undo">Effacer</vs-button>
                    </div>
                </div>
            </div>
            </vs-tab>

            <vs-tab @click="CloseCamera" label="Paiement">
            <div class="con-tab-ejemplo">
                <div class="vs-component vs-con-input-label vs-input   w-full vs-input-primary" v-if="dataIntervention.invoice_api_id && dataIntervention && dataIntervention.invoice_status != 'paid'">
                    <label for="textarea-default" class="vs-input--label mt-5">Mode de règlement</label>
                    <v-select  class="w-full" :clearable="false" label="label" v-model="modeReglement" :options="payment_type_choices" :reduce="payment_type => payment_type.value" :dir="$vs.rtl ? 'rtl' : 'ltr'" >
                        <div slot="no-options">Désolé, aucune etat correspondante.</div>
                    </v-select>
                </div>


                <vs-input label="Saisir le montant" v-model="inter_amount" class="w-full mb-2" name="lastname" v-if="!dataIntervention.invoice_api_id"/>

                <div class="vx-row" v-if="dataIntervention && dataIntervention.invoice_status != 'paid'">
                    <div class="vx-col w-full mb-base">
                    <vs-input label="Email" v-model="client_email" class="w-full mb-2" />
                    </div>
                </div>

                <vs-button id="sendBtn" color="success" type="border" class="w-full vs-con-loading__container" @click="sendPUrl" v-if="dataIntervention && dataIntervention.invoice_status != 'paid'">
                    <feather-icon icon="SendIcon" svgClasses="h-4 w-4" /> Envoyer lien de paiement
                </vs-button>

                <p class="text-center text-success mt-5" v-if="sendSuccess == true"><feather-icon icon="CheckCircleIcon" svgClasses="h-4 w-4" /> Le lien est bien envoyé.</p>
                <p class="text-center text-danger mt-5" v-if="sendSuccess == false"><feather-icon icon="AlertCircleIcon" svgClasses="h-4 w-4" /> Le lien de paiement n’a pas été envoyé. <br> Merci de bien vouloir réessayer</p>

                 <div class="vx-row" v-if="dataIntervention && dataIntervention.invoice_status == 'paid'">
                    <div class="vx-col w-full text-center">
                        <img src="https://uxwing.com/wp-content/themes/uxwing/download/48-checkmark-cross/success-green-check-mark.png" alt="" class="w-32">
                        <h1 style="color: #01a601;">Payé</h1>
                    </div>
                </div>
            </div>
            </vs-tab>

            <vs-tab @click="OpenCamera" label="Photo" >
                <div class="con-tab-ejemplo">
                    <div class="web-camera-container">
                        <div class="camera-button">
                         
                        </div>

                        <div v-show="isCameraOpen && isLoading" class="camera-loading">
                            <ul class="loader-circle">
                            <li></li>
                            <li></li>
                            <li></li>
                            </ul>
                        </div>

                        <div v-if="isCameraOpen" v-show="!isLoading" class="camera-box" :class="{ 'flash' : isShotPhoto }" style="display: flex;justify-content: center;">

                            <div class="camera-shutter" :class="{'flash' : isShotPhoto}"></div>

                            <video v-show="!isPhotoTaken" ref="camera"  autoplay playsinline muted></video>

                            <canvas v-show="isPhotoTaken" id="photoTaken" ref="canvas"></canvas>
                        </div>

                        <div v-if="isCameraOpen && !isLoading && !isPhotoTaken" class="camera-shoot text-center">
                            <button type="button" class="button" @click="takePhoto">
                            <img src="https://img.icons8.com/material-outlined/50/000000/camera--v2.png">
                            </button>
                        </div>

                        <div v-if="isPhotoTaken && isCameraOpen" class="camera-download mt-5 text-center">
                            <vs-button type="gradient" color="success" @click="save">Enregistrer</vs-button>
                            <vs-button type="gradient" color="danger" class="ml-2" @click="cancel">Annuler</vs-button>
                        </div>

                        <div class="vx-row mt-5">
                            <div class="vx-col w-full">
                                <vx-card>
                                <h5 class="mb-2"> Photos </h5>
                                    <div class="content-center">
                                        <silent-box ref="silentbox" :gallery="gallery" v-if="gallery.length">
                                            <template v-slot:silentbox-item="{ silentboxItem }">
                                                <img :src="silentboxItem.src" style="width: 50px !important;margin-right: 5px;border-radius: 5px;">
                                                <vs-button color="danger" type="flat" class="w-full" @click.prevent="deleteImage(silentboxItem.id)"><feather-icon icon="Trash2Icon" svgClasses="h-4 w-4" /></vs-button>
                                            </template>
                                        </silent-box>
                                    </div>
                                </vx-card>
                            </div>
                        </div>

                    </div>
                </div>
            </vs-tab>

        </vs-tabs>

        <div class="text-center flex-wrap items-center p-2" slot="footer">
      <vs-button type="border" color="danger" @click="fermer">Fermer</vs-button>
    </div>
    </vs-sidebar>
</template>

<script>

import { mapActions } from 'vuex'
import vSelect from 'vue-select'

import { Validator } from 'vee-validate';
const dict = {
  custom: {
    inter_amount: {
      required: 'Le montant est obligatoire'
    }
  }
}

export default {
    name: 'MySignaturePad',
    components: {
      vSelect
    },

    props: ['isSidebarActive','intervention_id','quote_api_id','signature','modeReglement','dataIntervention','client_email'],
    data () {
        
        return {
            colorx:'success',
            image : {id: null, base64: null},
            isCameraOpen: false,
            isPhotoTaken: false,
            isShotPhoto: false,
            isLoading: false,
            link: '#',

            showCamera: false,
            gallery: [],

            payment_type_choices : [
                {value: 'card', label: 'Carte bancaire'},
                {value: 'transfer', label: 'Virement bancaire'},
                {value: 'cash', label: 'Espèces'},
                {value: 'cheque', label: 'Chèque'},
                {value: 'paypal', label: 'Paypal'},
            ],

            width : 320,
            height : 0,
            sendSuccess: null,
            inter_amount: null,

        
  
        }
    },
    
    computed: {

        isSidebarActiveLocal: {
            get() {
                return this.isSidebarActive
            },
            set(val) {
                if(!val) {
                this.$emit('closeSidebar')
                this.initValues(true)
                }
            },
        },

        image_signature() {
            //https://api.hellodepann.fr/
            //http://localhost:8000
            return 'https://api.hellodepann.fr/signature/'+this.quote_api_id+'.png'
        } 
    },

    methods: {
        ...mapActions('interventions', {'addImage':'addImage','saveImage':'saveImage','fetchImages' : 'fetchImages','removeImage' : 'removeImage', 'sendPaiementUrl': 'sendPaiementUrl'}),
        ...mapActions('quotes', {'updateModeReglement':'updateModeReglement'}),

     
        undo() {
        this.$refs.signaturePad.undoSignature();
        },
        save_signature() {
            const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
            this.image.id = this.quote_api_id;
            this.image.base64 = data;

            this.saveImage(this.image).then(() => {
                this.successMsg("Modification","L'enregistrement' l'image est bien effectué");
            }).catch(() => {
                this.errorMsg('Modification',"Trouvé un error L'enregistrement' l'image")
            })

        },

    
        OpenCamera() {
            this.isCameraOpen = true;
            this.createCameraElement();
        },

        CloseCamera() {
            if(this.isCameraOpen){
                this.isCameraOpen = false;
                this.isPhotoTaken = false;
                this.isShotPhoto = false;
                this.stopCameraStream(); 
            }
            
        },

        fermer() {
            this.CloseCamera();
            this.isSidebarActiveLocal = false
        },


         changeModeReglement() {
            this.updateModeReglement({id: this.quote_api_id, value: this.modeReglement.value})
        },



        createCameraElement() {
            this.isLoading = true;

            const constraints = (window.constraints = {
                audio: false,
                video: this.$isMobile() ? { facingMode: 'environment' } : true
            });


            navigator.mediaDevices
            .getUserMedia(constraints)
            .then(stream => {
                this.isLoading = false;
                this.$refs.camera.srcObject = stream;

                let stream_settings  = stream.getVideoTracks()[0].getSettings()
                this.height = stream_settings.height / (stream_settings.width / this.width)

                if (isNaN(this.height)) {
                    this.height = this.width / (4 / 3);
                }

                this.$refs.camera.setAttribute('width', this.width);
                this.$refs.camera.setAttribute('height', this.height);

                this.$refs.canvas.setAttribute('width', this.width);
                this.$refs.canvas.setAttribute('height', this.height);
            })
            .catch(error => {
                this.isLoading = false;
                alert("May the browser didn't support or there is some errors.");
            });
        },

        stopCameraStream() {
            let tracks = this.$refs.camera.srcObject.getTracks();

            tracks.forEach(track => {
                track.stop();
            });
        },

        takePhoto() {
            if(!this.isPhotoTaken) {
                this.isShotPhoto = true;

                const FLASH_TIMEOUT = 50;

                setTimeout(() => {
                this.isShotPhoto = false;
                }, FLASH_TIMEOUT);
            }

            this.isPhotoTaken = !this.isPhotoTaken;

            const context = this.$refs.canvas.getContext('2d');
            context.drawImage(this.$refs.camera, 0, 0, this.width, this.height);
        },
        cancel() {
            this.isPhotoTaken = false
        },

        save() {
            var obj = {
                image : document.getElementById("photoTaken").toDataURL("image/jpeg"),
                id: this.intervention_id
            }

            this.addImage(obj).then(result => {
  
                this.$emit('addImage', result.data)
                this.gallery.push(result.data)

                this.successMsg("L'ajout","Le photo est bien ajouté");
                this.cancel()
            }).catch(() => {

                this.errorMsg('L\'Ajout','Trouvé un error lor de l\'insertion')
            })
        },

        successMsg(title,msg){
            this.$vs.notify({
                title: title,
                text: msg,
                color:'success',
                iconPack: 'feather',
                icon:'icon-check',
                position:'top-right'
            })
        },

        errorMsg(title,msg){
            this.$vs.notify({
                title: title,
                text: msg,
                color:'danger',
                iconPack: 'feather',
                icon:'icon-check',
                position:'top-right'
            })
        },

        addImageToGallery(image) {
            this.gallery.push(image)
        },

        deleteImage(id) {
            this.removeImage(id).then(() => {
                const ItemIndex = this.gallery.findIndex((p) => p.id == id)
                this.gallery.splice(ItemIndex, 1)
                this.$refs.silentbox.hideOverlay()
                this.successMsg("Supprission photo","La photo est bien supprimé");
            }).catch(() => {
                this.errorMsg('Supprission photo','Trouvé un error lor de la supprission')
            })
        },

        sendPUrl() {


            if (!this.dataIntervention.invoice_api_id && !this.inter_amount) {
                this.sendSuccess = false

                setTimeout(() => {
                    this.sendSuccess = null
                }, 5000);
            }else{
                if (!this.client_email) {
                    this.sendSuccess = false

                    setTimeout(() => {
                        this.sendSuccess = null
                    }, 5000);
                }else{

                    this.$vs.loading({
                        background: '#fff',
                        color: 'success',
                        container: '#sendBtn',
                        scale: 0.45
                    })
                    
                    this.sendPaiementUrl({id: this.intervention_id, amount: this.inter_amount, email: this.client_email}).then(() => {
                        this.inter_amount = null
                        this.sendSuccess = true
                        this.$vs.loading.close('#sendBtn>.con-vs-loading')

                        setTimeout(() => {
                            this.sendSuccess = null
                        }, 5000);
                    }).catch(() => {
                        this.inter_amount = null
                        this.sendSuccess = false
                        this.$vs.loading.close('#sendBtn>.con-vs-loading')

                        setTimeout(() => {
                            this.sendSuccess = null
                        }, 5000);
                    })
                }
            }

        }
    },
    watch: {
        'intervention_id'(val) {
            this.$emit('changeId', val)
            if(!val) this.errors.items = []

            this.fetchImages(val).then(response => {
                this.gallery = response.data
            })
        },
    },

    mounted(){

    }

}
</script>

<style lang="scss" scoped>
    .sign-photo-sidebar {
        ::v-deep .vs-sidebar--background {
        z-index: 52010;
        }

        ::v-deep .vs-sidebar {
            z-index: 52010;
            width: 100vw;
            max-width: 100vw;

            .img-upload {
                margin-top: 2rem;

                .con-img-upload {
                padding: 0;
                }

                .con-input-upload {
                width: 100%;
                margin: 0;
                }

                .silentbox-item .vs-button{
                    padding: -0.25rem 2rem;
                }
            }
        }
    }

  

    [dir] .vx-card .vx-card__collapsible-content .vx-card__body {
        padding: 1rem;
    }

    .con-tab{
        height: calc(100vh);
    }

    // video{
    //     width: 100%;
    // }

</style>
        